<template>
<div>
	<div class="t-headline10 font-b mgb-8 pdl-24 pdr-24">{{$t('1')}}</div>
		<div class="t-body1 t-color-bodyGrayA font-r pdl-24 pdr-24">{{$t('32')}}</div>
		<div class="mgt-24 pdl-24 pdr-24 position-relative">
			<div v-for="(method, index) in findId.authMethods" :key="index">
			<div class="pdt-6 pdb-6" v-if="method.findWay.value === 'SMS'">
				<div class="mdc-form-field">
					<div class="mdc-radio mdc--radio__custom">
							<input class="mdc-radio__native-control" type="radio"
								name="findType"
								:id="'findType'+method.findWay.value"
								:value="method.findWay.value"
								v-model="findType"
								@click="setValue(method.value.phone,method.value.fullPhoneNumber)" @keypress="setValue(method.value.phone,method.value.fullPhoneNumber)" tabindex="0"
							>
							<div class="mdc-radio__background">
									<div class="mdc-radio__outer-circle"></div>
									<div class="mdc-radio__inner-circle"></div>
							</div>
							<div class="mdc-radio__ripple"></div>
					</div>
					<label :for="'findType'+method.findWay.value" v-if="method.findWay.value === 'SMS'" class="t-body1 font-r l-spacing48">
						{{$t('33')}}
					</label>
				</div>
			</div>
			<div class="pdt-6 pdb-6" v-if="method.findWay.value === 'EMAIL'">
				<div class="mdc-form-field">
					<div class="mdc-radio mdc--radio__custom">
							<input class="mdc-radio__native-control"
								type="radio"
								name="findType"
								:id="'findType'+method.findWay.value"
								:value="method.findWay.value"
								v-model="findType"
								@click="setValue(method.value,'')" @keypress="setValue(method.value,'')" tabindex="0"
							>
							<div class="mdc-radio__background">
								<div class="mdc-radio__outer-circle"></div>
								<div class="mdc-radio__inner-circle"></div>
							</div>
							<div class="mdc-radio__ripple"></div>
					</div>
					<label :for="'findType'+method.findWay.value" v-if="method.findWay.value === 'EMAIL'" class="t-body1 font-r l-spacing48">
						{{$t('34')}}
					</label>
				</div>
			</div>
		</div>
		</div>
		<div class="mgt-50 mgb-50 pdl-24 pdr-24">
			<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8 b-radius4" @click="getCertiNumber()" @keypress="getCertiNumber()">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r">{{$t('35')}}</span>
			</button>
			<button class="mdc-button t-color-secondaryBtnText b-radius4" @click="cancelFindId()" @keypress="cancelFindId()" tabindex="0">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r">{{$t('36')}}</span>
			</button>
		</div>
</div>
</template>

<script>
/**
 * 계정 찾기 Step3 컴포넌트 (find account Step3 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'
import {findIdMixin} from '../../mixins/findId.js'

export default {
	data() {
		return {
			findType: '',
			value: '',
			fullPhoneNumber: ''
		}
	},

	mixins: [findIdMixin],

	computed: {
		...mapState('findId',{
			findId : state => state,
		})
	},

	mounted() {
		// 인증 수단이 없을 경우 Step1로 이동(If there is no authentication method, go to Step1)
		if (!this.findId.authMethods.length) {
      this.pathName ? this.$moveLogin() : this.$moveBrandSelect();
		}
		this.setMaterialUi()

	},

	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('findId', ['SET_STEP2','SET_STEP3']),

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		// 인증수단 설정(Authentication method setting)
		setValue(value,phoneNoWithCountry) {
			this.value = value
			this.fullPhoneNumber = phoneNoWithCountry ? phoneNoWithCountry:value
		},

		// 인증번호 발송 API 호출(Authentication number sending API call)
		getCertiNumber() {
			if (!this.findType || !this.value){
				this.$snackOpen({
					contents: this.$t('32')
				}).then(() => {})
				// this.$snackOpen({contents:'계정 찾기를 위한 코드를 받을 방법을 선택하세요.'}).then(() => {})
				return
			}

			let params = {
				findWay: this.findType,
				value: this.value
			}

			this.SET_STEP2(params)

			let responseData = null

			// set certi number
			findApi.requestFindId(params).then((response) => {
				responseData = response.data.data
				this.SET_STEP3({
					value: this.value,
					token: responseData.token,
					fullPhoneNumber: this.fullPhoneNumber
				})

				this.$router.push({
					name: 'FindIdStep4'
				})
			}).catch((err) => {
				responseData = err.response.data.meta
				this.$error({content: responseData.errMsg}).then(() => {})

			})
		},
	},
}
</script>
